(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/hooks/assets/javascripts/use-search-params.js') >= 0) return;  svs.modules.push('/components/casino-react/hooks/assets/javascripts/use-search-params.js');
"use strict";


const {
  useQueryParam
} = svs.components.lbUtils;
const useSearchParams = () => {
  const searchQueryParam = useQueryParam('q');
  const categoriesQueryParam = useQueryParam('categories');
  const providersQueryParam = useQueryParam('providers');
  const listIdsParam = useQueryParam('listIds');
  const tagsQueryParam = useQueryParam('tags');
  const sortingQueryParam = useQueryParam('sorting');
  const returnUrlParam = useQueryParam('returnUrl');
  const tabUrlParam = useQueryParam('tab');
  return {
    q: searchQueryParam ? decodeURIComponent(searchQueryParam) : '',
    categories: categoriesQueryParam ? decodeURIComponent(categoriesQueryParam).split(',') : [],
    providers: providersQueryParam ? decodeURIComponent(providersQueryParam).split(',') : [],
    listIds: listIdsParam ? decodeURIComponent(listIdsParam).split(',') : [],
    tags: tagsQueryParam ? decodeURIComponent(tagsQueryParam).split(',') : [],
    sorting: sortingQueryParam ? decodeURIComponent(sortingQueryParam) : '',
    returnUrl: returnUrlParam ? decodeURIComponent(returnUrlParam) : '',
    tab: tabUrlParam ? decodeURIComponent(tabUrlParam) : ''
  };
};
setGlobal('svs.components.casino_react.hooks.useSearchParams', useSearchParams);

 })(window);